import { LaunchDates } from '../../server/utils/launchDateConstants';

const status301 = 301;

/* make all from links lowercase since we force that in the path */
const homepageRoute = '/';
const impactRoute = '/impact';
const faqRoute = '/faq';
const preferredCustomerRoute = '/preferred';

const seasonalWineClubDateGate = new Date() > LaunchDates.seasonalWineClub;
// currently, /wine-club is being directed to /maris-picks. lets reverse that for seasonal wineclub
const wineClubFrom = seasonalWineClubDateGate
  ? '/shop/product/maris-picks'
  : '/shop/product/wine-club';
const wineClubTo = seasonalWineClubDateGate ? '/wine-club' : '/maris-picks';

export const redirectConfig = [
  /* Homepage */
  {
    from: '/heart',
    to: homepageRoute,
    status: status301,
  },
  {
    from: '/the-grapeful-club',
    to: preferredCustomerRoute,
    status: status301,
  },
  {
    from: '/shop',
    to: homepageRoute,
    status: status301,
  },
  /* Homepage End */
  /* Static Pages */
  {
    from: '/host-a-tasting',
    to: '/host',
    status: status301,
  },
  {
    from: '/become-a-ceo',
    to: '/join',
    status: status301,
  },
  /* Static Pages End */
  /* Impact */
  {
    from: '/causes/cure-alzheimers-disease/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/educate-our-girls/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/end-childhood-bullying/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/end-childhood-hunger/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/end-global-disease/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/end-hunger/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/end-poverty/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/fight-against-breast-cancer/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/fight-against-cancer/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/fund-arts-education/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/fund-pet-adoptions/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/help-build-schools/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/help-children-with-autism/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/help-end-homelessness/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/increase-literacy/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/literacy-education/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/prevent-heart-disease/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/prevent-ovarian-cancer/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/prevent-prostate-cancer/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/provide-clean-water/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/provide-healthcare/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/save-endangered-species/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/save-our-planet/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/save-young-lives/',
    to: impactRoute,
    status: status301,
  },
  {
    from: '/causes/support-our-troops/',
    to: impactRoute,
    status: status301,
  },
  /* Impact End */
  /* FAQ */
  {
    from: '/contact-us/',
    to: faqRoute,
    status: status301,
  },
  {
    from: '/contact-us/event-wine-request/',
    to: faqRoute,
    status: status301,
  },
  {
    from: '/contact-us/general-inquiries/',
    to: faqRoute,
    status: status301,
  },
  {
    from: '/contact-us/press-inquiries/',
    to: faqRoute,
    status: status301,
  },
  {
    from: '/frequently-asked-questions/',
    to: faqRoute,
    status: status301,
  },
  {
    from: '/privacy/',
    to: '/privacy-policy',
    status: status301,
  },
  {
    from: '/return-policy/',
    to: faqRoute,
    status: status301,
  },
  {
    from: '/shipping/',
    to: faqRoute,
    status: status301,
  },
  /* FAQ End */
  /* Products */
  /* Product Category */
  {
    from: '/our-wines/white-wine/sauvignon-blanc/',
    to: '/shop/wine/wine-white',
    status: status301,
  },
  {
    from: '/product-category/coffee/',
    to: '/shop/coffee/coffee',
    status: status301,
  },
  {
    from: '/product-category/gifts/',
    to: '/shop/gifts/gift',
    status: status301,
  },
  {
    from: '/product-category/gifts/gift-boxes/',
    to: '/shop/gifts/gift',
    status: status301,
  },
  {
    from: '/product-category/gifts/gift-crates/',
    to: '/shop/gifts/gift',
    status: status301,
  },
  {
    from: '/product-category/gifts/kitchen-products/',
    to: '/shop/kitchen/kitchen',
    status: status301,
  },
  {
    from: '/product-category/gifts/non-alcoholic-gifts/',
    to: '/shop/gifts/gift-non-alcoholic',
    status: status301,
  },
  {
    from: '/product-category/gifts/wood-gift-boxes/',
    to: '/shop/gifts/gift',
    status: status301,
  },
  {
    from: '/product-category/prosecco/',
    to: '/shop/wine/wine-prosecco',
    status: status301,
  },
  {
    from: '/product-category/marketplace/',
    to: '/shop/gifts/gift-marketplace',
    status: status301,
  },
  {
    from: '/product-category/swag/',
    to: '/shop/gifts/gift-swag',
    status: status301,
  },
  {
    from: '/product-category/prosecco/',
    to: '/shop/wine/wine-prosecco',
    status: status301,
  },
  {
    from: '/product-category/viognier/',
    to: '/shop/wine/wine-viognier',
    status: status301,
  },
  {
    from: '/product-category/wine/',
    to: '/shop/wine/wine',
    status: status301,
  },
  {
    from: '/product-category/wine/core-collection/',
    to: '/shop/wine/wine-collection-core',
    status: status301,
  },
  {
    from: '/product-category/wine/dessert-wine/',
    to: '/shop/wine/wine-dessert',
    status: status301,
  },
  {
    from: '/product-category/wine/estate-wine/',
    to: '/shop/wine/wine-collection-iconic',
    status: status301,
  },
  {
    from: '/product-category/wine/glitter-bottles/',
    to: '/shop/wine/wine-glitter',
    status: status301,
  },
  {
    from: '/product-category/wine/iconic-collection/',
    to: '/shop/wine/wine-collection-iconic',
    status: status301,
  },
  {
    from: '/product-category/wine/limited-edition-wine/',
    to: '/shop/wine/wine-collection-limited',
    status: status301,
  },
  {
    from: '/product-category/wine/mixed-packs/',
    to: '/shop/wine/wine-collection-mixed',
    status: status301,
  },
  {
    from: '/product-category/wine/red-wine/',
    to: '/shop/wine/wine-red',
    status: status301,
  },
  {
    from: '/product-category/wine/red-wine/cabernet-sauvignon/',
    to: '/shop/wine/wine-cabernet',
    status: status301,
  },
  {
    from: '/product-category/wine/red-wine/malbec/',
    to: '/shop/wine/wine-malbec',
    status: status301,
  },
  {
    from: '/product-category/wine/red-wine/merlot/',
    to: '/shop/wine/wine-merlot',
    status: status301,
  },
  {
    from: '/product-category/wine/red-wine/pinot-noir/',
    to: '/shop/wine/wine-pinot-noir',
    status: status301,
  },
  {
    from: '/product-category/wine/red-wine/red-blend/',
    to: '/shop/wine/wine-red-blend',
    status: status301,
  },
  {
    from: '/product-category/wine/red-wine/zinfandel/',
    to: '/shop/wine/wine-zinfandel',
    status: status301,
  },
  {
    from: '/product-category/wine/reserve-wine/',
    to: '/shop/wine/wine-collection-reserve',
    status: status301,
  },
  {
    from: '/product-category/wine/rose-wine/',
    to: '/shop/wine/wine-rose',
    status: status301,
  },
  {
    from: '/product-category/wine/signature-series/',
    to: '/shop/wine/wine-collection-signature',
    status: status301,
  },
  {
    from: '/product-category/wine/sparkling-wine/',
    to: '/shop/wine/wine-sparkling',
    status: status301,
  },
  {
    from: '/product-category/wine/white-wine/',
    to: '/shop/wine/wine-white',
    status: status301,
  },
  {
    from: '/product-category/wine/white-wine/chardonnay/',
    to: '/shop/wine/wine-chardonnay',
    status: status301,
  },
  {
    from: '/product-category/wine/white-wine/fume-blanc/',
    to: '/shop/wine/wine-fume-blanc',
    status: status301,
  },
  {
    from: '/product-category/wine/white-wine/muscat-canelli/',
    to: '/shop/wine/wine-muscat-canelli',
    status: status301,
  },
  {
    from: '/product-category/wine/white-wine/pinot-grigio/',
    to: '/shop/wine/wine-pinot-grigio',
    status: status301,
  },
  {
    from: '/product-category/wine/white-wine/riesling/',
    to: '/shop/wine/wine-riesling',
    status: status301,
  },
  {
    from: '/product-category/wine/white-wine/sauvignon-blanc/',
    to: '/shop/wine/wine-sauvignon-blanc',
    status: status301,
  },
  {
    from:
      '/product/onehope-darius-rucker-signature-series-2009-napa-cabernet-sauvignon/',
    to: '/shop/wine/wine-collection-signature',
    status: status301,
  },
  /* Product Category End */
  /* Products Wine */
  {
    from: '/shop/1-5l-magnum-ca-cabernet-sauvignon/',
    to: '/shop/product/california-cabernet-sauvignon-magnum',
    status: status301,
  },
  {
    from: '/shop/12-bottle-case-mini-glitter-sparkling-brut-gold/',
    to:
      '/shop/product/california-brut-sparkling-wine-mini-gold-glitter-twelve-case',
    status: status301,
  },
  {
    from: '/shop/12-bottle-case-mini-glitter-sparkling-brut-silver/',
    to:
      '/shop/product/california-brut-sparkling-wine-mini-silver-glitter-twelve-case',
    status: status301,
  },
  {
    from: '/shop/2-bottle-wodd-gift-box-ca-red-blend-zinfandel/',
    to: '/shop/product/2-bottle-wood-gift-box-red-blend-zinfandel',
    status: status301,
  },
  {
    from: '/shop/2-bottle-wood-gift-box-ca-rose-riesling/',
    to: '/shop/product/2-bottle-wood-gift-box-rose-riesling',
    status: status301,
  },
  {
    from: '/shop/2-bottle-wood-gift-box-cabernet-sauvignon-chardonnay/',
    to: '/shop/product/2-bottle-wood-gift-box-chardonnay-cabernet-17',
    status: status301,
  },
  {
    from: '/shop/2-bottle-wood-gift-box-cabernet-sauvignon-merlot/',
    to: '/shop/product/2-bottle-wood-gift-box-cabernet-merlot-17',
    status: status301,
  },
  {
    from: '/shop/2-bottle-wood-gift-box-estate-fume-blanc-sauvignon-blanc/',
    to: '/shop/product/2-bottle-wood-gift-box-estate-fume-sauvignon-blanc',
    status: status301,
  },
  {
    from: '/shop/2-bottle-wood-gift-sparkling-brut-chardonnay/',
    to: '/shop/product/2-bottle-wood-gift-box-brut-chardonnay',
    status: status301,
  },
  {
    from: '/shop/2-bottle-wood-gift-sparkling-brut-chardonnay/',
    to: '/shop/product/2-bottle-wood-gift-box-brut-chardonnay',
    status: status301,
  },
  {
    from: '/shop/onehope-california-cabernet-sauvignon/',
    to: '/shop/product/california-cabernet-sauvignon',
    status: status301,
  },
  {
    from: '/shop/2008-sonoma-coast-reserve-syrah/',
    to: '/shop/product/sonoma-coast-reserve-syrah',
    status: status301,
  },
  {
    from: '/shop/2012-california-red-wine-blend/',
    to: '/shop/product/california-red-blend',
    status: status301,
  },
  {
    from: '/shop/2013-joseph-jewell-russian-river-valley-chardonnay/',
    to: '/shop/product/joseph-jewell-russian-river-valley-chardonnay',
    status: status301,
  },
  {
    from: '/shop/2013-san-luis-obispo-reserve-pinot-noir/',
    to: '/shop/product/san-luis-obispo-reserve-pinot-noir',
    status: status301,
  },
  {
    from: '/shop/2014-california-reserve-gsm/',
    to: '/shop/product/california-reserve-red-blend-gsm',
    status: status301,
  },
  {
    from: '/shop/2014-carneros-reserve-chardonnay/',
    to: '/shop/product/carneros-reserve-chardonnay',
    status: status301,
  },
  {
    from: '/shop/2014-edna-valley-reserve-pinot-noir/',
    to: '/shop/product/edna-valley-reserve-pinot-noir-14',
    status: status301,
  },
  {
    from: '/shop/2014-estate-sauvignon-blanc/',
    to: '/shop/product/rutherford-estate-sauvignon-blanc',
    status: status301,
  },
  {
    from: '/shop/2014-estate-fume-blanc/',
    to: '/shop/product/rutherford-estate-fume-blanc',
    status: status301,
  },
  {
    from: '/shop/2014-estate-sauvignon-blanc/',
    to: '/shop/product/rutherford-estate-sauvignon-blanc',
    status: status301,
  },
  {
    from: '/shop/2014-howell-mountain-cabernet-sauvignon/',
    to: '/shop/product/howell-mountain-cabernet-sauvignon',
    status: status301,
  },
  {
    from: '/shop/2015-napa-valley-oakville-cabernet-sauvignon/',
    to: '/shop/product/oakville-cabernet-sauvignon',
    status: status301,
  },
  {
    from: '/shop/2015-napa-valley-reserve-cabernet-sauvignon/',
    to: '/shop/product/napa-valley-reserve-cabernet-sauvignon-2015',
    status: status301,
  },
  {
    from: '/shop/2015-napa-valley-reserve-merlot/',
    to: '/shop/product/napa-valley-reserve-merlot-2015',
    status: status301,
  },
  {
    from: '/shop/2015-napa-valley-reserve-red-blend/',
    to: '/shop/product/napa-valley-reserve-red-blend-2015',
    status: status301,
  },
  {
    from: '/shop/2015-north-coast-reserve-zinfandel/',
    to: '/shop/product/north-coast-reserve-zinfandel-2015',
    status: status301,
  },
  {
    from: '/shop/2016-argentina-uco-valley-malbec/',
    to: '/shop/product/argentina-uco-valley-malbec',
    status: status301,
  },
  {
    from: '/shop/2016-california-muscat-canelli/',
    to: '/shop/product/california-muscat-canelli',
    status: status301,
  },
  {
    from: '/shop/2016-california-symphony/',
    to: '/shop/product/california-symphony',
    status: status301,
  },
  {
    from: '/shop/2016-california-viognier/',
    to: '/shop/product/california-viognier',
    status: status301,
  },
  {
    from: '/shop/2016-central-coast-reserve-rose/',
    to: '/shop/product/central-coast-reserve-rose',
    status: status301,
  },
  {
    from: '/shop/2016-central-coast-riesling/',
    to: '/shop/product/central-coast-reserve-riesling',
    status: status301,
  },
  {
    from: '/shop/2016-napa-valley-reserve-petite-sirah/',
    to: '/shop/product/napa-valley-petite-sirah',
    status: status301,
  },
  {
    from: '/shop/2016-pinot-grigio-delle-venezie-igt/',
    to: '/shop/product/delle-venezie-igt-pinot-grigio',
    status: status301,
  },
  {
    from: '/shop/2016-prosecco-brut-millesimato-doc/',
    to: '/shop/product/brut-millesiamato-doc-prosecco',
    status: status301,
  },
  {
    from: '/shop/2016-sonoma-reserve-rose/',
    to: '/shop/product/sonoma-reserve-rose',
    status: status301,
  },
  {
    from: '/shop/29-twelve-california-dessert-wine-vii/',
    to: '/shop/product/29-twelve-california-dessert-wine-vii',
    status: status301,
  },
  {
    from: '/shop/3-bottle-wood-gift-box-cabernet-sauvignon-merlot-pinot-noir/',
    to: '/shop/product/3-bottle-wood-gift-box-brut-sauv-blanc-pinot-noir',
    status: status301,
  },
  {
    from:
      '/shop/3-bottle-wood-gift-box-sparkling-brut-sauvignon-blanc-pinot-noir/',
    to: '/shop/product/3-bottle-wood-gift-box-brut-sauv-blanc-pinot-noir',
    status: status301,
  },
  {
    from:
      '/shop/4-bottle-wood-gift-box-sparkling-brut-chardonnay-cabernet-merlot/',
    to: '/shop/product/4-bottle-california-mixed-wine-wood-gift-box-17',
    status: status301,
  },
  {
    from:
      '/shop/4-bottle-wood-gift-box-sparkling-brut-chardonnay-cabernet-merlot/',
    to: '/shop/product/4-bottle-california-mixed-wine-wood-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/aww-baby-gift-box/',
    to: '/shop/product/aww-baby-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/award-winning-mixed-pack/',
    to: '/shop/product/award-winning-mixed-pack-subscription',
    status: status301,
  },
  {
    from: '/shop/best-of-california-mixed-pack/',
    to: '/shop/product/best-of-california-mixed-pack',
    status: status301,
  },
  {
    from: '/shop/birthday-babe-gift-box-2/',
    to: '/shop/product/birthday-babe-gift-box-17',
    status: status301,
  },
  {
    from: '/bronzeglitter/',
    to: '/shop/product/california-brut-sparkling-wine-bronze-glitter-edition',
    status: status301,
  },
  {
    from: '/shop/ca-sparkling-brut-gold-shimmer-bottle/',
    to: '/shop/product/california-brut-sparkling-wine-gold-shimmer-edition',
    status: status301,
  },
  {
    from: '/shop/california-reds-mixed-pack/',
    to: '/shop/product/california-reds-3-mixed-pack',
    status: status301,
  },
  {
    from: '/shop/california-riesling/',
    to: '/shop/product/california-riesling',
    status: status301,
  },
  {
    from: '/shop/california-rose/',
    to: '/shop/product/california-rose',
    status: status301,
  },
  {
    from: '/shop/california-white-sparkling-mixed-pack/',
    to: '/shop/product/california-white-and-sparkling-mixed-pack',
    status: status301,
  },
  {
    from: '/shop/californian-gift-box/',
    to: '/shop/product/the-californian-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/carneros-reserve-pinot-noir/',
    to: '/shop/product/carneros-reserve-pinot-noir',
    status: status301,
  },
  {
    from: '/shop/celebration-brut-methode-champenoise/',
    to: '/shop/product/california-celebration-brut-sparkling-wine-17',
    status: status301,
  },
  {
    from: '/shop/celebration-brut-single-bottle-wood-gift-box-3/',
    to: '/shop/product/single-bottle-wood-gift-box',
    status: status301,
  },
  {
    from: '/shop/celebration-pack-gift-box/',
    to: '/shop/product/celebration-gift-pack-17',
    status: status301,
  },
  {
    from: '/shop/celebration-pack-gift-box/',
    to: '/shop/product/celebration-gift-pack-17',
    status: status301,
  },
  {
    from: '/shop/cheese-party-gift-crate/',
    to: '/shop/product/cheese-party-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/chris-paul-signature-series-napa-valley-reserve-pinot-noir/',
    to: '/shop/product/chris-paul-signature-series-napa-valley-pinot-noir',
    status: status301,
  },
  {
    from: '/shop/cookies-cab-gift-box-2/',
    to: '/shop/product/cookies-and-cabernet-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/core-collection-single-bottle-wood-gift-box/',
    to: '/shop/product/single-bottle-wood-gift-box',
    status: status301,
  },
  {
    from: '/shop/day-golf-gift-box/',
    to: '/shop/product/day-of-golf-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/deluxe-duo-gift-crate-3/',
    to: '/shop/product/the-deluxe-duo-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/dip-spread-set/',
    to: '/shop/product/kitchen-dip-and-spread-set',
    status: status301,
  },
  {
    from: '/shop/edna-valley-pinot-noir-red-glitter-bottle/',
    to: '/shop/product/edna-valley-pinot-noir-red-glitter-2014',
    status: status301,
  },
  {
    from: '/shop/estate-sauvignon-blanc-single-wood-gift-box/',
    to: '/shop/product/single-bottle-wood-gift-box-estate-sauvignon-blanc',
    status: status301,
  },
  {
    from: '/shop/four-bottle-california-reds-wood-gift-box/',
    to: '/shop/product/4-bottle-california-reds-wood-gift-box',
    status: status301,
  },
  {
    from: '/shop/four-bottle-mixed-california-wine-wood-gift-box/',
    to: '/shop/product/4-bottle-california-mixed-wine-wood-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/frose-gift-box-coming-soon/',
    to: '/shop/product/frose-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/giving-keys-gift-box-2/',
    to: '/shop/product/the-giving-keys-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/glitter-brut-single-bottle-wood-gift-box-3/',
    to: '/shop/product/single-bottle-wood-gift-box-brut-gold',
    status: status301,
  },
  {
    from: '/shop/glitter-celebration-gift-pack/',
    to: '/shop/product/celebration-gift-pack-silver-glitter-17',
    status: status301,
  },
  {
    from: '/shop/gold-celebration-brut-methode-champenoise/',
    to:
      '/shop/product/california-celebration-brut-sparkling-wine-gold-glitter-17',
    status: status301,
  },
  {
    from: '/shop/gold-glitter-edition-brut-sparkling-wine/',
    to: '/shop/product/california-brut-sparkling-wine-gold-glitter-edition',
    status: status301,
  },
  {
    from: '/shop/gold-shimmer-single-bottle-wood-gift-box/',
    to: '/shop/product/single-bottle-wood-gift-box-brut-gold-shimmer',
    status: status301,
  },
  {
    from: '/shop/good-karma-gift-box/',
    to: '/shop/product/good-karma-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/grill-chill-gift-box/',
    to: '/shop/product/grill-chill-gift-box',
    status: status301,
  },
  {
    from: '/shop/healthy-dish-essentials-set/',
    to: '/shop/product/healthy-dish-essentials-set',
    status: status301,
  },
  {
    from: '/shop/heart-warmer-gift-box-2/',
    to: '/shop/product/heart-warmer-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/holiday-dinner-mixed-pack/',
    to: '/shop/product/holiday-dinner-wine-mixed-pack',
    status: status301,
  },
  {
    from: '/shop/hustle-mini-gift-crate-coming-soon/',
    to: '/shop/product/hustle-mini-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/just-mini-gift-crate/',
    to: '/shop/product/just-because-mini-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/lighter-side-gift-box/',
    to: '/shop/product/the-lighter-side-17',
    status: status301,
  },
  {
    from:
      '/shop/limited-edition-onehope-10-year-anniversary-2012-napa-valley-cabernet-sauvignon-1-5l-magnum/',
    to: '/shop/product/onehope-10-year-napa-valley-cabernet-sauvignon',
    status: status301,
  },
  {
    from:
      '/shop/limited-edition-onehope-10-year-anniversary-2015-california-cabernet-sauvignon-1-5l-mangum/',
    to: '/shop/product/onehope-10-year-california-cabernet-sauvignon',
    status: status301,
  },
  {
    from:
      '/shop/limited-edition-onehope-10-year-anniversary-2015-california-cabernet-sauvignon-1-5l-mangum/',
    to: '/shop/product/onehope-10-year-california-cabernet-sauvignon',
    status: status301,
  },
  {
    from: '/shop/mixologist-gift-box/',
    to: '/shop/product/the-mixologist-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/morning-man-gift-box/',
    to: '/shop/product/morning-man-gift-box',
    status: status301,
  },
  {
    from: '/shop/napa-picnic-gift-crate-coming-soon/',
    to: '/shop/product/the-napa-picnic-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/napa-taster/',
    to: '/shop/product/kitchen-napa-taster-set',
    status: status301,
  },
  {
    from: '/shop/napa-valley-cabernet-sauvignon-single-bottle-wood-gift-box/',
    to: '/shop/product/single-bottle-wood-gift-box',
    status: status301,
  },
  {
    from: '/shop/north-coast-reserve-sparkling-brut/',
    to: '/shop/product/north-coast-reserve-sparkling-brut-2016',
    status: status301,
  },
  {
    from: '/shop/north-coast-reserve-sparkling-rose/',
    to: '/shop/product/north-coast-reserve-sparkling-rose-2016',
    status: status301,
  },
  {
    from: '/shop/oil-vinegar-set-coming-soon/',
    to: '/shop/product/kitchen-oil-and-vinegar-set',
    status: status301,
  },
  {
    from: '/shop/onehope-10-year-anniversary-hats-white/',
    to: '/shop/product/swag-onehope-hat-10-year',
    status: status301,
  },
  {
    from: '/shop/onehope-cabernet-sauvignon-gift-duo/',
    to: '/shop/product/2-bottle-white-gift-box-duo',
    status: status301,
  },
  {
    from: '/shop/onehope-california-brut-sparkling-wine/',
    to: '/shop/product/california-brut-sparkling-wine',
    status: status301,
  },
  {
    from: '/shop/onehope-california-cabernet-sauvignon/',
    to: '/shop/product/california-cabernet-sauvignon',
    status: status301,
  },
  {
    from: '/shop/onehope-california-chardonnay/',
    to: '/shop/product/california-chardonnay',
    status: status301,
  },
  {
    from: '/shop/onehope-california-merlot/',
    to: '/shop/product/california-merlot',
    status: status301,
  },
  {
    from: '/shop/onehope-california-pinot-noir/',
    to: '/shop/product/california-pinot-noir',
    status: status301,
  },
  {
    from: '/shop/onehope-california-sauvignon-blanc/',
    to: '/shop/product/california-sauvignon-blanc',
    status: status301,
  },
  {
    from: '/shop/onehope-california-zinfandel/',
    to: '/shop/product/california-zinfandel',
    status: status301,
  },
  {
    from: '/shop/onehope-california-zinfandel/',
    to: '/shop/product/california-zinfandel',
    status: status301,
  },
  {
    from: '/shop/onehope-california-zinfandel/',
    to: '/shop/product/california-zinfandel',
    status: status301,
  },
  {
    from: '/shop/onehope-glitter-edition-brut-sparkling-wine/',
    to: '/shop/product/california-brut-sparkling-wine-silver-glitter-edition',
    status: status301,
  },
  {
    from: '/shop/onehope-hats-black/',
    to: '/shop/product/swag-onehope-hat',
    status: status301,
  },
  {
    from: '/shop/onehope-hats-grey/',
    to: '/shop/product/swag-onehope-hat',
    status: status301,
  },
  {
    from: '/shop/onehope-hats-white/',
    to: '/shop/product/swag-onehope-hat',
    status: status301,
  },
  {
    from: '/shop/onehope-karma-blend-whole-bean-coffee-1lb/',
    to: '/shop/product/karma-blend-whole-bean-coffee-one-pound-black',
    status: status301,
  },
  {
    from: '/shop/onehope-womens-hoodies-grey/',
    to: '/shop/product/swag-onehope-womens-hoodies-grey',
    status: status301,
  },
  {
    from: '/shop/pantry-essentials-gift-box-coming-soon/',
    to: '/shop/product/pantry-essentials-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/pasta-brushetta-set-coming-soon/',
    to: '/shop/product/kitchen-pasta-and-bruschetta-set',
    status: status301,
  },
  {
    from: '/shop/pasta-wine-gift-crate-2/',
    to: '/shop/product/pasta-and-wine-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/peppermint-gift-box/',
    to: '/shop/product/peppermint-gift-box',
    status: status301,
  },
  {
    from: '/shop/picnic-perfect-gift-crate-coming-soon/',
    to: '/shop/product/picnic-perfect-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/pinot-party-gift-crate-coming-soon/',
    to: '/shop/product/pinot-party-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/pinot-paws-meow-gift-box/',
    to: '/shop/product/pinot-for-paws-meow-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/pinot-paws-woof-gift-box/',
    to: '/shop/product/pinot-for-paws-woof-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/pride-gift-box/',
    to: '/shop/product/pride-box-17',
    status: status301,
  },
  {
    from: '/shop/pumpkin-spice-latte-gift-box/',
    to: '/shop/product/pumpkin-spice-gift-box',
    status: status301,
  },
  {
    from: '/shop/rainbow-glitter-edition-brut-sparkling-wine/',
    to: '/shop/product/california-brut-sparkling-wine-rainbow-glitter-edition',
    status: status301,
  },
  {
    from: '/shop/red-wine-gift-box-2/',
    to: '/shop/product/red-wine-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/reserve-cotes-de-provence-rose/',
    to: '/shop/product/cotes-de-provence-reserve-rose',
    status: status301,
  },
  {
    from: '/shop/rose-macrame-gift-box/',
    to: '/shop/product/rose-macrame-gift-box-17',
    status: status301,
  },
  {
    from:
      '/shop/sara-evans-signature-series-2014-napa-valley-cabernet-sauvignon/',
    to:
      '/shop/product/sara-evans-signature-series-napa-valley-cabernet-sauvignon',
    status: status301,
  },
  {
    from: '/shop/sauced-gift-box-non-alcoholic/',
    to: '/shop/product/sauced-gift-box',
    status: status301,
  },
  {
    from: '/shop/savory-sauces-set/',
    to: '/shop/product/kitchen-savory-sauces-set',
    status: status301,
  },
  {
    from: '/shop/silver-celebration-brut-methode-champenoise/',
    to:
      '/shop/product/california-celebration-brut-sparkling-wine-silver-glitter-17',
    status: status301,
  },
  {
    from: '/shop/single-bottle-core-collection-white-gift-box/',
    to: '/shop/product/single-bottle-white-gift-box',
    status: status301,
  },
  {
    from: '/shop/sparkling-wine-glitter-bottle-3-pack/',
    to:
      '/shop/product/california-brut-sparkling-wine-silver-glitter-three-pack',
    status: status301,
  },
  {
    from: '/shop/sweet-tooth-mini-gift-crate/',
    to: '/shop/product/sweet-tooth-mini-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/the-great-crate-2/',
    to: '/shop/product/the-great-crate-17',
    status: status301,
  },
  {
    from: '/shop/the-mixologist-gift-box/',
    to: '/shop/product/the-mixologist-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/trefethen-cabernet-sauvignon/',
    to: '/shop/product/onehope-x-trefethen-family-cabernet-sauvignon',
    status: status301,
  },
  {
    from: '/shop/unisex-black-crew-neck-tee-grey-lettering/',
    to: '/shop/product/swag-onehope-unisex-crew-neck-tee',
    status: status301,
  },
  {
    from: '/shop/unisex-black-v-neck-tee-gold-lettering/',
    to: '/shop/product/swag-onehope-unisex-vneck-tee',
    status: status301,
  },
  {
    from: '/shop/unisex-grey-crew-neck-tee/',
    to: '/shop/product/swag-onehope-unisex-crew-neck-tee',
    status: status301,
  },
  {
    from: '/shop/unisex-grey-v-neck-tee/',
    to: '/shop/product/swag-onehope-unisex-vneck-tee',
    status: status301,
  },
  {
    from: '/shop/unisex-light-grey-crew-tee/',
    to: '/shop/product/swag-onehope-unisex-crew-neck-tee',
    status: status301,
  },
  {
    from: '/shop/unisex-light-grey-v-neck-tee/',
    to: '/shop/product/swag-onehope-unisex-vneck-tee',
    status: status301,
  },
  {
    from: '/shop/unisex-white-crew-neck-tee-grey-lettering/',
    to: '/shop/product/swag-onehope-unisex-crew-neck-tee',
    status: status301,
  },
  {
    from: '/shop/unisex-white-v-neck-tee-grey-lettering/',
    to: '/shop/product/swag-onehope-unisex-vneck-tee',
    status: status301,
  },
  {
    from: '/shop/walker-gift-box-gift-box/',
    to: '/shop/product/the-walker-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/walker-gift-box-gift-box/',
    to: '/shop/product/the-walker-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/white-wine-gift-box-2/',
    to: '/shop/product/white-wine-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/will-bridesmaid-mini-gift-crate/',
    to: '/shop/product/will-you-be-my-bridesmaid-mini-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/wine-cheese-party-gift-crate/',
    to: '/shop/product/wine-and-cheese-party-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/wine-grind-gift-box-2/',
    to: '/shop/product/wine-and-grind-gift-box-17',
    status: status301,
  },
  {
    from: '/shop/womens-one-year-anniversary-tank/',
    to: '/shop/product/swag-onehope-womens-tank-10-year',
    status: status301,
  },
  {
    from: '/shop/woof-gift-crate-17/',
    to: '/shop/product/woof-gift-crate-17',
    status: status301,
  },
  {
    from: '/shop/world-of-good-gift-box/',
    to: '/shop/product/world-of-good-gift-box-17',
    status: status301,
  },
  {
    from: '/award-winning-mixed-pack',
    to: '/shop/product/award-winning-mixed-pack-subscription',
    status: status301,
  },
  {
    from: '/bronzeglitter',
    to:
      '/shop/product/vintner-collection-ca-pinot-noir-bronze-glitter-edition-pc',
    status: status301,
  },
  {
    from: '/celebration-set',
    to: '/shop/product/celebration-set-gift-box-19',
    status: status301,
  },
  {
    from: '/naughty-and-nice',
    to: '/shop/product/naughty-nice-wood-gift-box-duo',
    status: status301,
  },
  {
    from: '/shimmer',
    to: '/shop/wine/wine-glitter',
    status: status301,
  },

  /* Products Wine End */
  /* Products End */
  /* Blog */
  {
    from: '/holiday-gift-wrapping',
    to: 'https://onehopewine.com/blog/holiday-gift-wrapping/',
    status: status301,
  },
  {
    from: '/holiday2020',
    to: 'https://www.onehopewine.com/blog/hope-at-home-holiday-2020-recipes/',
    status: status301,
  },
  {
    from: '/harvest2020',
    to: 'https://www.onehopewine.com/blog/harvest-2020-recipes/',
    status: status301,
  },
  {
    from: '/spring2020',
    to: 'https://www.onehopewine.com/blog/spring-2020-recipes/',
    status: status301,
  },
  {
    from: '/winter2020',
    to: '/blog/hope-at-home-winter-2020/',
    status: status301,
  },
  {
    from: '/blog/super-bowl-food-wine-pairings',
    to: '/blog/big-game-food-wine-pairings',
    status: status301,
  },
  {
    from: '/summer2019',
    to: '/blog/hope-at-home-recipes-summer-2019',
    status: status301,
  },
  {
    from: '/candypairings',
    to: '/blog/halloween-candy-and-wine-pairings/',
    status: status301,
  },
  /* Blog End */
  /* Marketing */
  {
    from: '/grazia',
    to: 'https://www.onehopewine.com/shop/product/grazia-signature-rose',
    status: status301,
  },
  {
    from: '/cookie-pairings',
    to: 'https://www.onehopewine.com/blog/holiday-cookie-wine-pairings/',
    status: status301,
  },
  {
    from: '/wineclub',
    to: '/?utm_source=cumulus&utm_medium=radio&utm_campaign=cumulus',
    status: status301,
  },
  {
    from: '/anthropologie',
    to:
      '/host?utm_source=onehopewine-partner&utm_medium=partner-redirect&utm_content=host40off&utm_campaign=partner-anthropologie-q42018',
    status: status301,
  },
  {
    from: '/fng',
    to:
      '/host?utm_source=onehopewine-partner&utm_medium=partner-redirect&utm_content=host40off&utm_campaign=partner-fng-q42018',
    status: status301,
  },
  {
    from: '/jcoco',
    to:
      '/shop/product/california-brut-sparkling-wine-gold-shimmer-edition?utm_source=onehopewine-partner&utm_medium=partner-redirect&utm_content=Shimmer10Doff&utm_campaign=partner-jcoco-q42018',
    status: status301,
  },
  {
    from: '/ktla',
    to: '/?utm_source=ktla&utm_medium=online&utm_campaign=ktla',
    status: status301,
  },
  // Shimmer Landing page marketing redirects - Holiday 2018
  {
    from: '/radio',
    to:
      '/shop/wine/wine-glitter?utm_source=KABC&utm_medium=radio&utm_campaign=ShimmerRadioQ42018',
    status: status301,
  },
  {
    from: '/star',
    to:
      '/shop/wine/wine-glitter?utm_source=onehopewine-advert&utm_medium=advert-redirect&utm_content=ShimmerAd&utm_campaign=advert-Star-q42018',
    status: status301,
  },
  {
    from: '/ls',
    to:
      '/shop/wine/wine-glitter?utm_source=onehopewine-advert&utm_medium=advert-redirect&utm_content=ShimmerAd&utm_campaign=advert-LifeandStyle-q42018',
    status: status301,
  },
  {
    from: '/intouch',
    to:
      '/shop/wine/wine-glitter?utm_source=onehopewine-advert&utm_medium=advert-redirect&utm_content=ShimmerAd&utm_campaign=advert-Intouch-q42018',
    status: status301,
  },
  {
    from: '/ok',
    to:
      '/shop/wine/wine-glitter?utm_source=onehopewine-advert&utm_medium=advert-redirect&utm_content=ShimmerAd&utm_campaign=advert-OkMag-q42018',
    status: status301,
  },
  // Corporate gifting
  {
    from: '/corporategifting',
    to: 'https://issuu.com/onehopewine/docs/corporate-gifting-catalog_2019',
    status: status301,
  },
  // Crush
  {
    from: '/crush',
    to: 'https://crush.onehopewine.com/',
    status: status301,
  },
  // Pencils of Promise Redirect
  {
    from: '/pop',
    to: 'https://pop.onehopewine.com/',
    status: status301,
  },
  // Podcast
  {
    from: '/abg',
    to:
      'https://www.onehopewine.com/?utm_source=podcast&utm_medium=podcast-redirect&utm_content=abg&utm_campaign=podcast-q4-2020',
    status: status301,
  },
  {
    from: '/afford',
    to:
      'https://www.onehopewine.com/?utm_source=podcast&utm_medium=podcast-redirect&utm_content=afford&utm_campaign=podcast-q4-2020',
    status: status301,
  },
  {
    from: '/bkp',
    to:
      'https://www.onehopewine.com/?utm_source=podcast&utm_medium=podcast-redirect&utm_content=bkp&utm_campaign=podcast-q4-2020',
    status: status301,
  },
  {
    from: '/femsplainers',
    to:
      'https://www.onehopewine.com/?utm_source=podcast&utm_medium=podcast-redirect&utm_content=femsplainers&utm_campaign=podcast-q4-2020',
    status: status301,
  },
  {
    from: '/let-it-out',
    to:
      'https://www.onehopewine.com/?utm_source=podcast&utm_medium=podcast-redirect&utm_content=let-it-out&utm_campaign=podcast-q4-2020',
    status: status301,
  },
  {
    from: '/lori',
    to:
      'https://www.onehopewine.com/?utm_source=podcast&utm_medium=podcast-redirect&utm_content=lori&utm_campaign=podcast-q4-2020',
    status: status301,
  },
  {
    from: '/murder-minute',
    to:
      'https://www.onehopewine.com/?utm_source=podcast&utm_medium=podcast-redirect&utm_content=murder-minute&utm_campaign=podcast-q4-2020',
    status: status301,
  },
  {
    from: '/sarah',
    to:
      'https://www.onehopewine.com/?utm_source=podcast&utm_medium=podcast-redirect&utm_content=sarah&utm_campaign=podcast-q4-2020',
    status: status301,
  },
  // Winery
  {
    from: '/spring-2021-grapetoglass',
    to: 'https://youtu.be/EMjhVQ2F0HA',
    status: status301,
  },
  {
    from: '/2020-collective',
    to: 'https://onehopewinery.com/2020-collective',
    status: status301,
  },
  {
    from: '/2020',
    to: 'https://www.onehopewinery.com/2020-collective-visionary',
    status: status301,
  },
  {
    from: '/winery',
    to: '/winemaking',
    status: status301,
  },
  {
    from: '/vineyard',
    to: '/winemaking',
    status: status301,
  },
  {
    from: '/etched',
    to: 'https://www.onehopewine.com/shop/wine/wine-etched',
    status: status301,
  },
  {
    from: '/etched-shimmer',
    to: 'https://www.onehopewine.com/shop/wine/wine-etched',
    status: status301,
  },
  {
    from: '/shop/wine/wine-cabernet',
    to: 'https://www.onehopewine.com/shop/wine/wine-red',
    status: status301,
  },
  //hope at home requests
  {
    from: '/gifts',
    to: 'https://www.onehopewine.com/shop/gifts',
    status: status301,
  },
  {
    from: wineClubFrom,
    to: `https://www.onehopewine.com/shop/product/${wineClubTo}`,
    status: status301,
  },
  {
    from: '/spring-2021',
    to: 'https://www.onehopewine.com/blog/spring-2021-hope-at-home-recipes/',
    status: status301,
  },
  {
    from: '/support',
    to: '/faq#contact',
    status: status301,
  },
  {
    from: '/summer-2021-grapetoglass',
    to: 'https://youtu.be/uNrkcjQbEA0',
    status: status301,
  },
  // wine club brochure requests
  {
    from: 'summer-2021',
    to: 'http://onehopewine.com/blog/summer-2021-hope-at-home-recipes',
    status: status301,
  },
  // tasting flight qr codes
  {
    from: '/taste1',
    to:
      'https://www.onehopewine.com/shop/product/vintner-collection-california-brut-sparkling',
    status: status301,
  },
  {
    from: '/taste2',
    to:
      'https://www.onehopewine.com/shop/product/vintner-california-chardonnay',
    status: status301,
  },
  {
    from: '/taste3',
    to:
      'https://www.onehopewine.com/shop/product/vintner-collection-california-pinot-noir',
    status: status301,
  },
  {
    from: '/taste4',
    to:
      'https://www.onehopewine.com/shop/product/vintner-collection-cabernet-sauvignon',
    status: status301,
  },
  {
    from: '/community-grant',
    to: 'https://onehopewine8.typeform.com/to/dCvmYjrv',
    status: status301,
  },
  /* Marketing End */
];

export const redirectConfigObj = redirectConfig.reduce(
  (acc, { from, to, status }) => {
    return {
      ...acc,
      [from]: {
        to,
        status,
      },
    };
  },
  {},
);
